import theme from '@styles/theme';
export default {
  searchContainer: (layoutBarsTotalHeight = 102) => ({
    position: 'relative',
    display: 'flex',
    flexFlow: ['column-reverse nowrap', 'column-reverse nowrap', 'column-reverse nowrap', 'column-reverse nowrap', 'row nowrap'],
    justifyContent: 'space-between',
    width: '100%',
    height: ['auto', 'auto', 'auto', 'auto', `calc(100vh - ${layoutBarsTotalHeight}px)`],
    minHeight: ['unset', 'unset', 'unset', 'unset', '800px'],
    pb: ['114px', '114px', '114px', '125px', '80px', 0]
  }),
  mapCol: {
    width: ['100%', '100%', '100%', '100%', 'calc(100% - 640px)'],
    p: '0 !important',
    minHeight: ['unset', 'unset', 'unset', 'unset', '800px']
  },
  searchCol: {
    width: ['100%', '100%', '100%', '100%', '640px'],
    p: '0 !important',
    minHeight: ['unset', 'unset', 'unset', 'unset', '800px']
  },
  filterHeader: {
    background: theme.rawColors.lightGrey300,
    m: '0 0 10px',
    p: '24px 0',
    gridTemplateColumns: ['2fr', '2fr', '2fr', '1fr 1fr']
  },
  mapRow: {
    background: theme.rawColors.lightGrey300,
    m: '0',
    gap: 0,
    gridTemplateColumns: ['24fr', '24fr', '24fr', '10fr 14fr']
  },
  locationCol: {
    p: ['24px 12px !important', '24px !important']
  },
  locationList: (counter: number) => ({
    height: counter < 3 ? ['auto', 'auto', 'auto', '552px'] : ['440px', '440px', '440px', '552px'],
    overflow: 'auto'
  })
};